const useSelectionsReports = () => {

  return {
    isLoading: false
  };
};

export default useSelectionsReports